export const defaultTicketRedemptionCodeFormData = {
    code: '',
    typeId: undefined,
    pin: ''
};
